function state() {
  return {
    commissionRequest: {},
    commissionRequestList: [],
    commissionRequestMeta: {},
  };
}

export default state;
